(() => {
  const WISHLIST_FORM = 'TXVn5f';
  const CART_FORMS = ['TYU7Rq', 'XDGBHp'];
  const ASKED_FORMS = ['Yij7Ge'];
  const WISHLIST_SLOT = 'br-wishlist-saved';
  const CART_SLOT = 'br-cart-saved';
  const SAVES_KEY = 'br-guest-saves';
  const SHOWN_KEY = 'br-form-shown:';
  const SUBMITTED_KEY = 'br-form-submitted:';
  const VISIT_KEY = 'br-popup-visit';
  const VISIT_GAP_MS = 1800000;
  const ACTIVE_EVERY_MS = 60000;
  const CLOSE_TRIES = 100;
  const CLOSE_WAIT_MS = 50;
  const CLOSING_MS = 5000;
  const FORM_ID = /^[A-Za-z0-9]{1,32}$/;
  const DIALOG = '[role="dialog"]';
  const CLOSE_BUTTON = 'button.klaviyo-close-form';
  const DAY_MS = 86400000;
  const SAVES_KEPT = 12;
  const SAVE_DAYS = 30;
  const QUIET_DAYS = 7;
  const SHOWN_ITEMS = 3;
  const SLOT_TRIES = 40;
  const SLOT_WAIT_MS = 50;
  const LEAVE_DOWN_PX = 600;
  const LEAVE_UP_PX = 200;
  const LEAVE_WITHIN_MS = 300;
  const TOP_PX = 80;
  const AWAY_MS = 3000;
  const REST_MS = 10000;
  const YIELD_MS = 300;
  const TOUCH_YIELD_MS = 2000;
  const CARD_PX = 100;
  const CARD_GAP_PX = 10;
  const CARD_IMAGE_PX = 240;
  const ROW_IMAGE_PX = 120;
  const VERSION_ATTRIBUTE = 'popup_';
  const VERSION_EVENTS = ['open', 'embedOpen'];
  const CART_UPDATE_PATH = '/cart/update.js';
  const CONSENT_API = [{ name: 'consent-tracking-api', version: '0.1' }];
  const QUIET_PATHS = /^\/(cart|checkout|checkouts|account)(\/|$)/;
  const PRODUCT_PATH = /\/products\/([^/?#]+)/;
  const INK = 'var(--br-ink, #0c0a09)';
  const SOFT_INK = 'var(--br-ink-soft, #44403b)';
  const LINE = 'var(--br-border, #e7e5e4)';
  const PAPER = 'var(--br-muted, #f5f5f4)';

  if (window.brPopups) return;

  const now = () => Date.now();

  const read = (key, fallback) => {
    try {
      const value = window.localStorage.getItem(key);
      return value === null ? fallback : JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const write = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  };

  const signedIn = () => Boolean(window.wishlist && window.wishlist.user && window.wishlist.user.email);

  const productPath = (url) => {
    const found = PRODUCT_PATH.exec(String(url || ''));
    return found ? `/products/${found[1]}` : null;
  };

  const saves = () => {
    const kept = read(SAVES_KEY, []);
    if (!Array.isArray(kept)) return [];
    return kept.filter(
      (save) => save && typeof save.path === 'string' && typeof save.at === 'number' && now() - save.at < SAVE_DAYS * DAY_MS,
    );
  };

  const remember = (data) => {
    if (signedIn() || !data) return;
    const path = productPath(data.url);
    if (!path) return;
    const variantId = data.variantId ? String(data.variantId) : null;
    const others = saves().filter((save) => save.path !== path || save.variantId !== variantId);
    others.unshift({
      path,
      variantId,
      name: typeof data.productName === 'string' ? data.productName : null,
      at: now(),
    });
    write(SAVES_KEY, others.slice(0, SAVES_KEPT));
  };

  const open = new Set();
  const blocking = new Set();
  const hidden = new Set();
  let asked = false;
  let signupForm = false;
  let visitHeld = null;
  let activeAt = 0;
  let hiddenStyle = null;

  const quiet = (form) => {
    const shown = read(SHOWN_KEY + form, 0);
    return read(SUBMITTED_KEY + form, false) === true || (typeof shown === 'number' && now() - shown < QUIET_DAYS * DAY_MS);
  };

  const current = (mark) =>
    mark && typeof mark.form === 'string' && typeof mark.seen === 'number' && now() - mark.seen <= VISIT_GAP_MS ? mark : null;

  const visit = () => current(read(VISIT_KEY, null)) || current(visitHeld);

  const keepVisit = (mark) => {
    visitHeld = mark;
    write(VISIT_KEY, mark);
  };

  const active = () => {
    if (now() - activeAt < ACTIVE_EVERY_MS) return;
    activeAt = now();
    const mark = visit();
    if (mark) keepVisit(Object.assign({}, mark, { seen: now() }));
  };

  const askedFor = (form) => ASKED_FORMS.indexOf(form) !== -1;

  const allowed = (form) => askedFor(form) || (!signupForm && visit() === null);

  const anotherPopup = () => open.size > 0 || signupForm || visit() !== null;

  const silence = (event) => {
    if (event && typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  };

  const drawHidden = () => {
    if (!hiddenStyle) {
      if (!document.head) return;
      hiddenStyle = document.createElement('style');
      document.head.appendChild(hiddenStyle);
    }
    hiddenStyle.textContent = Array.from(hidden)
      .map((form) => {
        const dialog = `${DIALOG}:has([data-testid="klaviyo-form-${form}"])`;
        return `${dialog},${dialog} *{visibility:hidden!important}`;
      })
      .join('');
  };

  const reveal = (form) => {
    blocking.delete(form);
    if (hidden.delete(form)) drawHidden();
  };

  const closeButtonOf = (form) => {
    const shown = document.querySelector(`[data-testid="klaviyo-form-${form}"]`);
    const box = shown && typeof shown.closest === 'function' ? shown.closest(DIALOG) : null;
    return box ? box.querySelector(CLOSE_BUTTON) : null;
  };

  const shut = (form) => {
    let tries = 0;
    let clickedAt = null;
    const look = () => {
      if (!blocking.has(form)) return;
      if (clickedAt === null) {
        const button = closeButtonOf(form);
        if (button) {
          clickedAt = now();
          button.click();
        }
      }
      tries += 1;
      const waitedOut = clickedAt === null ? tries >= CLOSE_TRIES : now() - clickedAt >= CLOSING_MS;
      if (waitedOut) reveal(form);
      else setTimeout(look, CLOSE_WAIT_MS);
    };
    look();
  };

  const block = (form) => {
    blocking.add(form);
    hidden.add(form);
    drawHidden();
    shut(form);
  };

  const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const emptyCart = () => json('/cart.js').then((cart) => Boolean(cart) && cart.item_count === 0);

  const leaving = () => {
    if (asked || anotherPopup() || signedIn() || QUIET_PATHS.test(window.location.pathname)) return;
    const kept = saves();
    if (kept.length === 0 || kept.some((save) => now() - save.at < REST_MS) || quiet(WISHLIST_FORM)) return;
    const klaviyo = window.klaviyo;
    if (!klaviyo || typeof klaviyo.isIdentified !== 'function') return;
    asked = true;
    Promise.all([emptyCart(), pause(touchScreen() ? TOUCH_YIELD_MS : YIELD_MS)])
      .then(([empty]) => {
        if (!empty) asked = false;
        if (!empty || anotherPopup()) return false;
        return Promise.resolve(klaviyo.isIdentified()).then((known) => !known);
      })
      .then((ready) => {
        if (!ready || anotherPopup()) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', WISHLIST_FORM]);
      })
      .catch(() => {
        asked = false;
      });
  };

  const touchScreen = () => typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;

  const watchLeaving = () => {
    document.addEventListener('mouseout', (event) => {
      if (event.relatedTarget || event.clientY > 0) return;
      leaving();
    });
    let deepest = 0;
    let recent = [];
    window.addEventListener(
      'scroll',
      () => {
        active();
        if (!touchScreen()) return;
        const y = window.scrollY;
        const at = now();
        deepest = Math.max(deepest, y);
        recent = recent.filter((mark) => at - mark.at <= LEAVE_WITHIN_MS).concat([{ y, at }]);
        const peak = Math.max(...recent.map((mark) => mark.y));
        if (deepest >= LEAVE_DOWN_PX && (peak - y >= LEAVE_UP_PX || y <= TOP_PX)) leaving();
      },
      { passive: true },
    );
    let hiddenAt = null;
    document.addEventListener('visibilitychange', () => {
      active();
      if (!touchScreen()) return;
      if (document.visibilityState === 'hidden') {
        hiddenAt = now();
        return;
      }
      const away = hiddenAt === null ? 0 : now() - hiddenAt;
      hiddenAt = null;
      if (away >= AWAY_MS) leaving();
    });
  };

  const element = (tag, styles, text) => {
    const node = document.createElement(tag);
    Object.assign(node.style, styles);
    if (text) node.textContent = text;
    return node;
  };

  const sized = (src, width) => {
    if (typeof src !== 'string' || src === '') return null;
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return null;
    }
  };

  const picture = (src, alt, styles) => {
    const image = element('img', Object.assign({ objectFit: 'cover', borderRadius: '3px', background: PAPER }, styles));
    image.src = src;
    image.alt = alt;
    image.loading = 'lazy';
    return image;
  };

  const json = (path) =>
    window
      .fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => (response && response.ok ? response.json() : null));

  const send = (path, body) =>
    window
      .fetch(path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
      .then((response) => (response && response.ok ? response.json() : null));

  const stamped = new Set();

  const stampVersion = (form, version) => {
    if (version === undefined || version === null || version === '' || stamped.has(form)) return;
    stamped.add(form);
    const key = VERSION_ATTRIBUTE + form;
    json('/cart.js')
      .then((cart) => {
        if (!cart) {
          stamped.delete(form);
          return null;
        }
        if ((cart.attributes || {})[key]) return null;
        return send(CART_UPDATE_PATH, { attributes: { [key]: String(version) } });
      })
      .catch(() => {
        stamped.delete(form);
      });
  };

  const marketingAllowed = () =>
    new Promise((resolve) => {
      const shopify = window.Shopify;
      const answer = () => {
        const privacy = shopify && shopify.customerPrivacy;
        resolve(Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed()));
      };
      if (shopify && shopify.customerPrivacy) {
        answer();
        return;
      }
      if (shopify && typeof shopify.loadFeatures === 'function') {
        shopify.loadFeatures(CONSENT_API, (error) => (error ? resolve(false) : answer()));
        return;
      }
      resolve(false);
    });

  let identifying = false;

  const identifySignedIn = () => {
    const klaviyo = window.klaviyo;
    if (identifying || !signedIn() || !klaviyo || typeof klaviyo.isIdentified !== 'function') return;
    identifying = true;
    marketingAllowed()
      .then((allowed) => (allowed ? Promise.resolve(klaviyo.isIdentified()).then((known) => !known) : false))
      .then((needed) => {
        if (!needed) {
          identifying = false;
          return;
        }
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['identify', { email: String(window.wishlist.user.email) }]);
      })
      .catch(() => {
        identifying = false;
      });
  };

  const card = (save, product) => {
    const title = (product && product.title) || save.name;
    if (!title) return null;
    const link = element('a', {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
      flex: `0 1 ${CARD_PX}px`,
      minWidth: '0',
      maxWidth: `${CARD_PX}px`,
      color: INK,
      textDecoration: 'none',
    });
    link.href = save.variantId ? `${save.path}?variant=${encodeURIComponent(save.variantId)}` : save.path;
    const src = sized(product && product.featured_image, CARD_IMAGE_PX);
    if (src) link.appendChild(picture(src, title, { display: 'block', width: '100%', aspectRatio: '1 / 1' }));
    link.appendChild(
      element(
        'span',
        {
          fontSize: '13px',
          lineHeight: '18px',
          color: SOFT_INK,
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
        },
        title,
      ),
    );
    return link;
  };

  const drawSaves = (slot) => {
    const picked = saves().slice(0, SHOWN_ITEMS);
    if (picked.length === 0) return;
    Promise.all(picked.map((save) => json(`${save.path}.js`).catch(() => null))).then((products) => {
      const cards = picked.map((save, index) => card(save, products[index])).filter(Boolean);
      if (cards.length === 0) return;
      Object.assign(slot.style, { display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', gap: `${CARD_GAP_PX}px` });
      slot.textContent = '';
      cards.forEach((item) => slot.appendChild(item));
    });
  };

  const moneyOf = (currency) => {
    try {
      const format = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' });
      return (cents) => format.format(cents / 100);
    } catch (error) {
      return (cents) => `$${(cents / 100).toFixed(2)}`;
    }
  };

  const row = (item, money) => {
    const path = productPath(item.url);
    const line = element(path ? 'a' : 'div', {
      display: 'flex',
      gap: '12px',
      alignItems: 'center',
      padding: '8px 0',
      borderTop: `1px solid ${LINE}`,
      color: INK,
      textDecoration: 'none',
    });
    if (path) line.href = item.variant_id ? `${path}?variant=${encodeURIComponent(String(item.variant_id))}` : path;
    const title = typeof item.product_title === 'string' ? item.product_title : '';
    const src = sized(item.image, ROW_IMAGE_PX);
    if (src) line.appendChild(picture(src, title, { width: '56px', height: '56px', flex: '0 0 56px' }));
    const words = element('span', { display: 'flex', flexDirection: 'column', gap: '2px', minWidth: '0', flex: '1 1 auto' });
    words.appendChild(element('span', { fontSize: '13px', lineHeight: '18px', fontWeight: '500' }, title));
    const size = typeof item.variant_title === 'string' && item.variant_title !== 'Default Title' ? item.variant_title : '';
    if (size) words.appendChild(element('span', { fontSize: '13px', lineHeight: '18px', color: SOFT_INK }, size));
    line.appendChild(words);
    if (typeof item.final_line_price === 'number') {
      line.appendChild(element('span', { fontSize: '13px', lineHeight: '18px', whiteSpace: 'nowrap' }, money(item.final_line_price)));
    }
    return line;
  };

  const drawCart = (slot) => {
    json('/cart.js')
      .then((cart) => {
        const items = cart && Array.isArray(cart.items) ? cart.items : [];
        if (items.length === 0) return;
        const money = moneyOf(cart.currency);
        slot.textContent = '';
        items.slice(0, SHOWN_ITEMS).forEach((item) => slot.appendChild(row(item, money)));
        const more = items.length - SHOWN_ITEMS;
        if (more > 0) {
          slot.appendChild(
            element('p', { margin: '8px 0 0', fontSize: '13px', lineHeight: '18px', color: SOFT_INK }, `+ ${more} more in your cart`),
          );
        }
      })
      .catch(() => undefined);
  };

  const fill = (id, draw) => {
    let tries = 0;
    const look = () => {
      const slot = document.getElementById(id);
      if (slot) {
        draw(slot);
        return;
      }
      tries += 1;
      if (tries < SLOT_TRIES) setTimeout(look, SLOT_WAIT_MS);
    };
    look();
  };

  window.brPopups = { remember, leaving, saves };

  window.addEventListener('br:published', (event) => {
    const detail = (event && event.detail) || {};
    if (detail.name === 'wishlist_item_saved') remember(detail.data);
  });

  window.addEventListener('klaviyoForms', (event) => {
    const detail = (event && event.detail) || {};
    const form = detail.formId ? String(detail.formId) : null;
    if (!form || !FORM_ID.test(form)) return;
    active();
    if (blocking.has(form)) {
      silence(event);
      if (detail.type === 'close') blocking.delete(form);
      return;
    }
    if (detail.type === 'embedOpen') signupForm = true;
    if (detail.type === 'open' && !allowed(form)) {
      silence(event);
      block(form);
      return;
    }
    if (VERSION_EVENTS.indexOf(detail.type) !== -1) stampVersion(form, detail.formVersionId);
    if (detail.type === 'open') {
      open.add(form);
      write(SHOWN_KEY + form, now());
      if (visit() === null) keepVisit({ form, at: now(), seen: now() });
      if (form === WISHLIST_FORM) fill(WISHLIST_SLOT, drawSaves);
      if (CART_FORMS.indexOf(form) !== -1) fill(CART_SLOT, drawCart);
    }
    if (detail.type === 'close') open.delete(form);
    if (detail.type === 'submit') write(SUBMITTED_KEY + form, true);
  });

  document.addEventListener('visitorConsentCollected', identifySignedIn);

  active();
  watchLeaving();
  identifySignedIn();
})();
